<div class="px-4 my-2">
    <h1>Not Found!</h1>
<h2 class=" text-danger">Error 404</h2>
<a class="btn btn-primary btn-lg my-5" routerLink="/profile" role="button">Back home</a>

</div>